import { render, staticRenderFns } from "./app-sound.vue?vue&type=template&id=272306b1"
import script from "./app-sound.vue?vue&type=script&lang=js"
export * from "./app-sound.vue?vue&type=script&lang=js"
import style0 from "./app-sound.vue?vue&type=style&index=0&id=272306b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports